<header class="header">
    @if (isAuthenticated()) {
        <button class="header__hamburger" (click)="toggleSidebar.emit()" aria-label="Toggle menu">
            <app-svg-icon name="menu" size="lg" />
        </button>
    }
    <a class="header__logo" routerLink="/">
        <img [src]="navigatorLogoPath" alt="Navigator Logo" class="header__logo-image" />
    </a>
    <span class="header__spacer"></span>
    <div class="header__actions header__actions--right">
        @if (isShikshaRoute()) {
            <div class="header__shiksha-filters">
                <label class="header__shiksha-label" for="shiksha-scope-dropdown">
                    {{ shikshaScopeLabel }}
                </label>
                <ei-dropdown
                    id="shiksha-scope-dropdown"
                    class="header__shiksha-scope"
                    [formControl]="shikshaScopeControl"
                    [config]="shikshaScopeDropdownConfig()"
                ></ei-dropdown>
                <label class="header__shiksha-label" for="shiksha-year-dropdown">{{
                    shikshaYearLabel
                }}</label>
                <ei-dropdown
                    id="shiksha-year-dropdown"
                    class="header__shiksha-year"
                    [formControl]="shikshaYearControl"
                    [config]="shikshaYearDropdownConfig()"
                ></ei-dropdown>
                <button
                    type="button"
                    class="header__shiksha-refresh"
                    (click)="refreshShikshaDashboard()"
                    [disabled]="isShikshaRefreshing()"
                    [attr.aria-label]="shikshaRefreshAriaLabel"
                >
                    <app-svg-icon class="header__shiksha-refresh-icon" name="refresh" size="md" />
                </button>
                <span class="header__shiksha-refresh-text">{{ shikshaRefreshLabel() }}</span>
            </div>
        }
        <!-- Sales Cycle (Home only) -->
        @if (showSalesCycle()) {
            <z-dropdown-menu class="sales-cycle-menu">
                <div
                    dropdown-trigger
                    class="sales-cycle-menu__trigger"
                    [attr.aria-label]="salesCycleLabel"
                >
                    <div class="header__sales-cycle">
                        <span class="header__sales-cycle-value">{{
                            selectedSalesCycle().label
                        }}</span>
                        <span class="header__sales-cycle-icon"
                            ><app-svg-icon name="keyboard_arrow_down" size="lg"
                        /></span>
                    </div>
                </div>

                <div class="sales-cycle-menu__list" role="menu" [attr.aria-label]="salesCycleLabel">
                    @for (option of salesCycleOptions(); track option.startYear) {
                        <z-dropdown-menu-item
                            class="sales-cycle-menu__item"
                            [class.sales-cycle-menu__item--selected]="
                                option.startYear === selectedSalesCycleStartYear()
                            "
                            (click)="selectSalesCycle(option.startYear)"
                        >
                            <span class="sales-cycle-menu__item-label">{{ option.label }}</span>
                        </z-dropdown-menu-item>
                    }
                </div>
            </z-dropdown-menu>
        }
        <!-- Notifications -->
        <z-dropdown-menu (openChange)="$event && onNotificationsMenuOpened()">
            <button
                class="header__action-btn header__notification relative"
                aria-label="Notifications"
                type="button"
                [disabled]="true"
                tabindex="-1"
                aria-disabled="true"
            >
                <app-svg-icon name="notifications" size="lg" />
                @if (notificationCount() > 0) {
                    <span class="header__notification-badge">{{ getNotificationCount() }}</span>
                }
            </button>
            <div class="menu__header">
                <span>Notifications</span>
            </div>
            <z-divider />
            <z-dropdown-menu-item>
                <app-svg-icon name="person_add" size="lg" />
                <span>New client registered</span>
                <span class="menu__time">2m ago</span>
            </z-dropdown-menu-item>
            <z-dropdown-menu-item>
                <app-svg-icon name="schedule" size="lg" />
                <span>Meeting schedule updated</span>
                <span class="menu__time">1h ago</span>
            </z-dropdown-menu-item>
        </z-dropdown-menu>
        <!-- Help & Support -->
        <z-dropdown-menu>
            <button
                class="header__action-btn"
                aria-label="Help"
                type="button"
                [disabled]="true"
                tabindex="-1"
                aria-disabled="true"
            >
                <app-svg-icon name="help_outline" size="lg" />
            </button>
            <z-dropdown-menu-item>
                <a routerLink="/help" class="flex items-center gap-2 w-full">
                    <app-svg-icon name="help" size="lg" />
                    <span>Help Center</span>
                </a>
            </z-dropdown-menu-item>
            <z-dropdown-menu-item>
                <a routerLink="/contact" class="flex items-center gap-2 w-full">
                    <app-svg-icon name="contact_support" size="lg" />
                    <span>Contact Support</span>
                </a>
            </z-dropdown-menu-item>
            <z-dropdown-menu-item>
                <a routerLink="/about" class="flex items-center gap-2 w-full">
                    <app-svg-icon name="info" size="lg" />
                    <span>About</span>
                </a>
            </z-dropdown-menu-item>
        </z-dropdown-menu>

        @if (isAuthenticated()) {
            <app-user-menu
                class="header__profile"
                [avatarPath]="userAvatarUrl()"
                [displayName]="userDisplayName()"
                [email]="userInfo?.email ?? ''"
            />
        } @else {
            <button (click)="signIn()" class="header__signin">
                <app-svg-icon name="login" size="lg" />
                <span>Sign In</span>
            </button>
        }
    </div>
</header>
